export default () => ({
  container: {
    width: '100%',
    overflowX: 'auto',
  },
});
